import React from "react";
import FoxTraderWelcome from "./FoxTraderWelcome/FoxTraderWelcome";
import KeyFeatures from "./KeyFeatures/KeyFeatures";
import FoxDownload from "./FoxDownload/FoxDownload";
function FoxTrader() {
  window.scrollTo(0, 0)
  return (
    <>
      <FoxTraderWelcome />
      <KeyFeatures />
      <FoxDownload />
    </>
  );
}
export default FoxTrader;
